module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hallgato.name != undefined) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "id": "name",
      "label": "Név",
      "name": "name"
    },
    model: {
      value: (_vm.hallgato.name),
      callback: function($$v) {
        _vm.hallgato.name = $$v
      },
      expression: "hallgato.name"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "id": "birth_country",
      "label": "Születési ország",
      "name": "birth_country"
    },
    model: {
      value: (_vm.hallgato.birth_country),
      callback: function($$v) {
        _vm.hallgato.birth_country = $$v
      },
      expression: "hallgato.birth_country"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "id": "birthdate",
      "label": "Születési dátum",
      "name": "birthdate"
    },
    model: {
      value: (_vm.hallgato.birthdate),
      callback: function($$v) {
        _vm.hallgato.birthdate = $$v
      },
      expression: "hallgato.birthdate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "id": "neptuncode",
      "label": "Neptun kód",
      "name": "neptuncode"
    },
    model: {
      value: (_vm.hallgato.neptuncode),
      callback: function($$v) {
        _vm.hallgato.neptuncode = $$v
      },
      expression: "hallgato.neptuncode"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "id": "birth_place",
      "label": "Születési hely",
      "name": "birth_place"
    },
    model: {
      value: (_vm.hallgato.birth_place),
      callback: function($$v) {
        _vm.hallgato.birth_place = $$v
      },
      expression: "hallgato.birth_place"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "id": "nationality",
      "label": "Állampolgárság",
      "name": "nationality"
    },
    model: {
      value: (_vm.hallgato.nationality),
      callback: function($$v) {
        _vm.hallgato.nationality = $$v
      },
      expression: "hallgato.nationality"
    }
  })], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "id": "country",
      "label": "Ország",
      "name": "country"
    },
    model: {
      value: (_vm.hallgato.country),
      callback: function($$v) {
        _vm.hallgato.country = $$v
      },
      expression: "hallgato.country"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "id": "city",
      "label": "Város",
      "name": "city"
    },
    model: {
      value: (_vm.hallgato.city),
      callback: function($$v) {
        _vm.hallgato.city = $$v
      },
      expression: "hallgato.city"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "id": "distance_gyor",
      "label": "Távolság Győrtől",
      "name": "distance_gyor"
    },
    model: {
      value: (_vm.hallgato.distance_gyor),
      callback: function($$v) {
        _vm.hallgato.distance_gyor = $$v
      },
      expression: "hallgato.distance_gyor"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "id": "postcode",
      "label": "Irányítószám",
      "name": "postcode"
    },
    model: {
      value: (_vm.hallgato.postcode),
      callback: function($$v) {
        _vm.hallgato.postcode = $$v
      },
      expression: "hallgato.postcode"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "id": "address",
      "label": "Cím",
      "name": "address"
    },
    model: {
      value: (_vm.hallgato.address),
      callback: function($$v) {
        _vm.hallgato.address = $$v
      },
      expression: "hallgato.address"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "id": "distance_ovar",
      "label": "Távolság Mosonmagyaróvártól",
      "name": "distance_ovar"
    },
    model: {
      value: (_vm.hallgato.distance_ovar),
      callback: function($$v) {
        _vm.hallgato.distance_ovar = $$v
      },
      expression: "hallgato.distance_ovar"
    }
  })], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "regexp_filter": "[0-9 +-/ ]+",
      "id": "phone_number",
      "label": "Telefonszám",
      "name": "phone_number"
    },
    model: {
      value: (_vm.hallgato.phone_number),
      callback: function($$v) {
        _vm.hallgato.phone_number = $$v
      },
      expression: "hallgato.phone_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": "disabled",
      "id": "email",
      "label": "E-mail",
      "name": "email"
    },
    model: {
      value: (_vm.hallgato.email),
      callback: function($$v) {
        _vm.hallgato.email = $$v
      },
      expression: "hallgato.email"
    }
  })], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('table', {
    staticClass: "list-table"
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.hallgato_szakok), function(hallgato_szak) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(hallgato_szak.KepzesKod))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hallgato_szak.KepzesNev))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hallgato_szak.Tagozat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hallgato_szak.Statusz))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hallgato_szak.PuStatusz))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hallgato_szak.Szemeszter))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hallgato_szak.Atlag))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hallgato_szak.Szakatlag))])])
  })], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('span', [_vm._v("Alapadatok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("Lakóhely adatok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("Kapcsolat adatok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("Tanulmányok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Képzés kódja")]), _vm._v(" "), _c('th', [_vm._v("Képzés neve")]), _vm._v(" "), _c('th', [_vm._v("Tagozat")]), _vm._v(" "), _c('th', [_vm._v("Státusz")]), _vm._v(" "), _c('th', [_vm._v("Pü. státusz")]), _vm._v(" "), _c('th', [_vm._v("Szemeszter")]), _vm._v(" "), _c('th', [_vm._v("Átlag")]), _vm._v(" "), _c('th', [_vm._v("Szakátlag")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3afbc1d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/hatar_hallgato_adatok.vue
// module id = 363
// module chunks = 0